export default {
  'inventory.create': 'New Inventory',
  'inventory.create.notifications.success.title': 'Sucess',
  'inventory.create.notifications.success.description':
    'Created Inventory Successfully.',

  'inventory.notifications.remove.confirm.title':
    'Do you really want to delete this inventory?',
  'inventory.notifications.remove.confirm.content':
    'By removing the inventory, all of their information will be permanently lost. Still want to continue?',
  'inventory.notifications.remove.confirm.okText': 'Remove customer',
  'inventory.notifications.remove.confirm.cancelText': 'Cancel',
  'inventory.notifications.remove.success.title':
    'Inventory successfully removed!',
  'inventory.notifications.remove.success.description':
    'Inventory has been successfully removed from the system',

  'inventory.update.notification.success': 'Success',
  'inventory.update.notification.successDescription': 'Inventory actualized!',

  'inventory.columns.table.company': 'Company',
  'inventory.columns.table.date': 'Date',
  'inventory.columns.table.inventoryReason': 'Inventory Reason',
  'inventory.columns.table.situation': 'Situation',
  'inventory.table.situation.inProgress': 'In progress',
  'inventory.table.situation.processing': 'Finalizing Inventory',
  'inventory.table.situation.done': 'Done',
  'inventory.table.situation.cancelled': 'Called off',
  'inventory.table.situation.importing': 'Importing',

  'inventory.form.modal.company': 'Company',
  'inventory.form.modal.inventoryReason': 'Inventory Reason',
  'inventory.form.modal.inventoryReason.endOfPeriod': 'End of Period',
  'inventory.form.modal.inventoryReason.changeFormGoods':
    'Change in the form of taxation of goods',
  'inventory.form.modal.inventoryReason.registrationLowRequest':
    'Registration low request',
  'inventory.form.modal.inventoryReason.changeOfPaymentRegime':
    'Change of payment regime',
  'inventory.form.modal.inventoryReason.taxDetermination':
    'Fisco Determination',
  'inventory.form.modal.date': 'Date',
  'inventory.form.modal.inventoryOf': 'I will inventory:',
  'inventory.form.modal.radio.part': 'Parts',
  'inventory.form.modal.radio.consumables': 'Consumables',
  'inventory.form.modal.radio.partsAndConsumables': 'Parts and Consumables',
  'inventory.form.modal.countFrom': 'Count From:',

  'inventory.detailPage.form.button.launchItemCount': 'Post item count',
  'inventory.detailPage.form.button.process': 'Process',
  'inventory.detailPage.fetchItems.message.firstCount': 'º Score',
  'inventory.detailPage.form.company': 'Company',
  'inventory.detailPage.form.inventoryReason': 'Inventory Reason',
  'inventory.detailPage.inventoryReason.endOfPeriod': 'End of Period',
  'inventory.detailPage.inventoryReason.changeFormGoods':
    'Change in the form of taxation of goods',
  'inventory.detailPage.inventoryReason.registrationLowRequest':
    'Registration low request',
  'inventory.detailPage.inventoryReason.changeOfPaymentRegime':
    'Change of payment regime',
  'inventory.detailPage.inventoryReason.taxDetermination':
    'Fisco Determination',
  'inventory.detailPage.form.date': 'Date',

  'inventory.page.form.modal.fetchItems.table.codeManufactures':
    'Code Manufacturer',
  'inventory.page.form.modal.fetchItems.table.description': 'Description',
  'inventory.page.form.modal.fetchItems.table.manufacturingCode':
    'Manufacturing Code',
  'inventory.page.form.modal.fetchItems.table.barCode': 'Bar Code',
  'inventory.page.form.modal.fetchItems.table.companyCode': 'Company Code',
  'inventory.page.form.modal.fetchItems.table.sku': 'Internal Code',
  'inventory.page.form.modal.fetchItems.table.manufacturerCode':
    'Manufacturer Code',
  'inventory.page.form.modal.fetchItems.table.currentInventory':
    'Current inventory',
  'inventory.page.form.modal.fetchItems.table.qtyCounted': 'Amo. Counted',
  'inventory.page.form.modal.fetchItems.table.vlUnitary': 'Vl. unitary',
  'inventory.page.form.modal.fetchItems.table.vlAmount': 'Amount',

  'inventory.page.form.modal.launchItemCount.title':
    'Launching inventory items',
  'inventory.page.form.modal.launchItems.subtitle':
    'Find a Part by internal, barcode, manufacturer code or description:',
  'inventory.page.form.modal.launchItemCount.description': 'Description',
  'inventory.page.form.modal.launchItemCount.currentInventory':
    'Current inventory',
  'inventory.page.form.modal.launchItemCount.codeManufacturers':
    'Manufacturing Code',
  'inventory.page.form.modal.launchItemCount.barCode': 'Bar code',
  'inventory.page.form.modal.launchItemCount.internalCode': 'Internal Code',
  'inventory.page.form.modal.launchItemCount.code': 'Code',
  'inventory.page.form.modal.launchItemCount.qtyCounted': 'Counted Quantity',
  'inventory.page.form.modal.launchItemCount.unitaryValue': 'Unitary value',
  'inventory.page.form.modal.table.launchItemCount.score': 'Score',
  'inventory.page.form.modal.table.launchItemCount.qtyCounted': 'Qty. Counted',

  'inventory.page.form.modal.processInventory.title': 'Next step of inventory:',
  'inventory.page.form.modal.processInventory.toNextCount': 'Go to next count',
  'inventory.page.form.modal.processInventory.finalizeInventory':
    'Finalize Inventory',

  'inventory.finalize.notification.success.title': 'Finalizing Inventory',
  'inventory.finalize.notification.success.description':
    'The moment your inventory is finished the status will change to "Finished"',
};
